import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { MeService } from './me.service';

export function provideAuthBootstrap(): EnvironmentProviders {
  return provideAppInitializer(async () => {
    const meService = inject(MeService);

    try {
      await firstValueFrom(meService.bootstrapMe());
    } catch {
      meService.clear();
    }
  });
}
